<ng-content *ngIf="!invalid && !loading"></ng-content>

<a [class]="btnClass" *ngIf="!invalid && !loading" href="#" (click)="validateCertificate($event)">
    {{ text }}
</a>

<span [class]="btnClass" *ngIf="!invalid && loading">
    Validando certificado...
</span>

<span [class]="btnClass" *ngIf="invalid && !loading">Erro ao validar certificado</span>
